import * as d3 from 'd3'
import theme from 'theme'
import { resolveThemeColor } from 'theme/config'
import { getActiveThemeMode } from 'theme/themeMode'

export const styledXAxisGroup = (xAxisGroup: d3.Selection<SVGGElement, unknown, null, undefined>) => {
  xAxisGroup
    .selectAll('text')
    .attr('color', resolveThemeColor('text-primary', getActiveThemeMode()))
    .attr('font-size', theme.typography.fontSize.large)
    .attr('font-weight', theme.typography.fontWeight.bold)
    .attr('letter-spacing', '0.1px')
    .attr('line-height', '22px')
    .attr('font-family', theme.typography.fontFamily.primary)
}
